import { Badge, Stack, Text } from '@mantine/core'
import { FormattedMessage } from 'react-intl'

export const IntegratedGpuNotice = () => (
  <Stack gap="xs">
    <Badge size="sm" color="gray.6" variant="light">
      <FormattedMessage id="devices.gpu.integrated" />
    </Badge>
    <Text size="xs" c="dimmed">
      <FormattedMessage id="deployments.gpuSettings.integratedGpuNotice" />
    </Text>
  </Stack>
)
